import Calendar from "../../Calendar/Calendar";
import {useEffect, useState} from "react";
import {retrieveAllTrainings} from "../../../Api/Associations/AssociationsFetch";

const Trainings = (props) => {
    const [events, setEvents] = useState([])
    const [isAll, setIsAll] = useState(false);
    const [trainings, setTrainings] = useState([]);

    useEffect(() => {
        if (props.teamDetails?.id) {
            retrieveAllTrainings({setTrainings, search: {team_id: props.teamDetails.id}});
        }
    }, [props.teamDetails?.id]);

    useEffect(() => {
        if (trainings && trainings.length > 0) {
            const teamColor = props.teamDetails?.color || 'var(--secondary)';
            const allEvents = trainings.flatMap(training =>
                training.training_schedules.map(schedule => ({
                    team_id: training.team_id,
                    team_name: training.team_name,
                    start: schedule.start_time,
                    end: schedule.end_time,
                    title: schedule.location,
                    description: schedule.description,
                    deadline: schedule.deadline,
                    id: schedule.schedule_id,
                    display: 'block',
                    type: schedule.type,
                    backgroundColor: teamColor,
                    borderColor: schedule.type === 1 ? 'transparent' : teamColor,
                    plan: schedule.plan,
                    players_limit: schedule.players_limit,
                    invitations: schedule.invitations
                }))
            );
            setEvents(allEvents);
        } else {
            setEvents([]);
        }
    }, [trainings, props.teamDetails?.color]);

    const refreshTrainings = () => {
        if (props.teamDetails?.id) {
            retrieveAllTrainings({setTrainings, search: {team_id: props.teamDetails.id}});
        }
    };

    const handleSetTeamDetail = (detail) => {
        props.setTeamDetail(detail);
        refreshTrainings();
    };

    return (
        <>
            <Calendar events={events} height={600} setEvents={setEvents} id={props.teamDetails && props.teamDetails.id}
                      team_id={props.teamDetails && props.teamDetails.id}
                      isAll={isAll}
                      setTeamDetail={handleSetTeamDetail} initalview={'dayGridMonth'}></Calendar>
        </>
    )
}

export default Trainings